import { IComponent } from '../schemamanager/types'
import { SchemaManager } from '../schemamanager/schemaManager'
import { MdAdd, MdDone, MdClear, MdEdit, MdContentCopy, MdDelete } from 'react-icons/md'
import { IDataTableComponent } from '../components/datatable'
import { IButtonComponent } from '../components/button'
import { IToolbarComponent } from '../components/toolbar'
import { IPanelComponent } from '../components/panel'
import cloneDeep from 'lodash.clonedeep';

export const DetailComponentButtons: IComponent = {
  type: 'panel',
  name: 'detailcomponentbuttons',
  classes: {
    display: 'flex',
    justifyContent: 'justify-end'
  },
  children: [
    {
      type: 'button',
      iconComp: MdDone,
      kind: 'flat',
      classes: {
        margin: 'mr-1',
      },
    },
    {
      type: 'button',
      iconComp: MdClear,
      themeColor: 'red',
      kind: 'flat',
      classes: {
        margin: 'mr-1',
      },
    }
  ]
}

export const DetailComponentButtonsFunc = (sm: SchemaManager, comp: IDataTableComponent): IComponent => {
  const buttons = cloneDeep(DetailComponentButtons)
  let c = buttons.children[0] as IButtonComponent
  c.label = sm.Strings.btn_ok
  c.onClick = () => {
    sm.SaveChangesDataTable(comp)
  }
  c = buttons.children[1] as IButtonComponent
  c.label = sm.Strings.btn_cancel
  c.onClick = () => {
    sm.RevertChangesDataTable(comp)
  }
  return buttons

}


export const DataTableToolbar = (sm: SchemaManager): IToolbarComponent => ({
  type: 'toolbar',
  children: [
    {
      type: 'button',
      tooltip: sm.Strings.ds_ins,
      kind: 'icon',
      iconComp: MdAdd,
    },
    {
      type: 'button',
      tooltip: sm.Strings.ds_copy,
      kind: 'icon',
      iconComp: MdContentCopy,
    },
    {
      type: 'button',
      tooltip: sm.Strings.ds_edit,
      kind: 'icon',
      iconComp: MdEdit,
    },
    {
      type: 'button',
      tooltip: sm.Strings.ds_del,
      kind: 'icon',
      themeColor: 'red',
      iconComp: MdDelete,
    }
  ]
})


export const DataTableToolbarFunc = (sm: SchemaManager, comp: IDataTableComponent): IToolbarComponent => {
  const toolbar = DataTableToolbar(sm)
  toolbar.label = comp.label || ''
  const options = comp.options!.toolbarActions!
  const editRowIndex: number = typeof comp.editRowIndex === 'undefined' ? -1 : comp.editRowIndex

  let c = toolbar.children[0] as IButtonComponent
  c.hidden = !options.add
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    sm.InsertDataTableRow(comp)
  }

  c = toolbar.children[1] as IButtonComponent
  c.hidden = !options.copy || !comp.options!.rowSelecting
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if ((typeof comp.selectedRowIndex !== 'undefined') && comp.selectedRowIndex > -1) {
      sm.InsertDataTableRow(comp, comp.selectedRowIndex)
    }
  }

  c = toolbar.children[2] as IButtonComponent
  c.hidden = !options.edit || !comp.options!.rowSelecting
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if ((typeof comp.selectedRowIndex !== 'undefined') && comp.selectedRowIndex > -1) {
      sm.EditDataTableRow(comp, comp.selectedRowIndex)
    }
  }

  c = toolbar.children[3] as IButtonComponent
  c.hidden = !options.delete || !comp.options!.rowSelecting
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if ((typeof comp.selectedRowIndex !== 'undefined') && comp.selectedRowIndex > -1) {
      sm.DeleteDataTableRow(comp, comp.selectedRowIndex)
    }
  }


  return toolbar

}

export const RowToolbarFunc = (sm: SchemaManager, comp: IDataTableComponent, arrayInd: number): IPanelComponent => {
  const rowToolbar = RowToolbar(sm);

  const options = comp.options!.rowActions!
  const editRowIndex: number = typeof comp.editRowIndex === 'undefined' ? -1 : comp.editRowIndex

  let c = rowToolbar.children[0] as IButtonComponent
  c.hidden = !options.add
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    sm.InsertDataTableRow(comp)
  }

  c = rowToolbar.children[1] as IButtonComponent
  c.hidden = !options.copy
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if (arrayInd > -1) {
      sm.InsertDataTableRow(comp, arrayInd)
    }
  }

  c = rowToolbar.children[2] as IButtonComponent
  c.hidden = !options.edit
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if (arrayInd > -1) {
      sm.EditDataTableRow(comp, arrayInd)
    }
  }

  c = rowToolbar.children[3] as IButtonComponent
  c.hidden = !options.delete
  c.disabled = editRowIndex > -1
  c.onClick = ({ event }) => {
    event.stopPropagation()
    if (arrayInd > -1) {
      sm.DeleteDataTableRow(comp, arrayInd)
    }
  }
  return rowToolbar

}


export const RowToolbar = (sm: SchemaManager): IPanelComponent => ({
  type: 'panel',
  classes: {
    padding: 'px-1 py-1',
  },
  children: [
    {
      type: 'button',
      kind: 'icon',
      tooltip: sm.Strings.ds_ins,
      iconComp: MdAdd,
      classes: {
        margin: 'mx-1',
        padding: 'px-1 py-1',
        height: 'h-8',
        width: 'w-8',
      },
    },
    {
      type: 'button',
      kind: 'icon',
      tooltip: sm.Strings.ds_copy,
      iconComp: MdContentCopy,
      classes: {
        margin: 'mx-1',
        padding: 'px-1 py-1',
        height: 'h-8',
        width: 'w-8',
      },
    },
    {
      type: 'button',
      tooltip: sm.Strings.ds_edit,
      kind: 'icon',
      iconComp: MdEdit,
      classes: {
        margin: 'mx-1',
        padding: 'px-1 py-1',
        height: 'h-8',
        width: 'w-8',
      },
    },
    {
      type: 'button',
      tooltip: sm.Strings.ds_del,
      kind: 'icon',
      themeColor: 'red',
      iconComp: MdDelete,
      classes: {
        margin: 'mx-1',
        padding: 'px-1 py-1',
        height: 'h-8',
        width: 'w-8',
      },
    }
  ]
})

